import React, { useState, useEffect } from "react";


interface WhatsAppSupportProps {
  delay?: number;
  name?: string;
  message?: string;
}

const WhatsAppSupport: React.FC<WhatsAppSupportProps> = ({
  delay = 30000,
  name = "Raquel Leão",
  message = "Olá! 😊\nPrecisa de ajuda para realizar sua matrícula?",
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showBubble, setShowBubble] = useState(false);
  const [isBubbleVisible, setIsBubbleVisible] = useState(false);
  const [isBubbleAnimated, setIsBubbleAnimated] = useState(false);

useEffect(() => {
    if (isBubbleVisible) {
        const autoClose = setTimeout(() => {
            handleBubbleClose();
        }, 15000);
        return () => clearTimeout(autoClose);
    }
}, [isBubbleVisible]);

  const formattedMessage = message.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < message.split("\n").length - 1 && <br />}
    </React.Fragment>
  ));

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      setTimeout(() => {
        setShowBubble(true);
        setTimeout(() => {
          setIsBubbleAnimated(true);
          setIsBubbleVisible(true);
        }, 100);
      }, 500);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [delay]);

  const handleBubbleClose = () => {
    setIsBubbleAnimated(false);

    setTimeout(() => {
      setIsBubbleVisible(false);
    }, 300);
  };

  const handleIconClick = () => {
    if (isBubbleVisible) {
      handleBubbleClose();
    } else {
      setShowBubble(true);
      setTimeout(() => {
        setIsBubbleAnimated(true);
        setIsBubbleVisible(true);
      }, 100);
    }
  };

  const handleWhatsAppRedirect = () => {
    window.open("https://api.whatsapp.com/send/?phone=5516996204989&text=Estou+na+p%C3%A1gina+de+compra+e+preciso+de+ajuda+para+realizar+minha+assinatura.&type=phone_number&app_absent=0", "_blank");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-5 left-5 z-50">
      {showBubble && isBubbleVisible && (
        <div
          className={`bg-white rounded-lg shadow-md mb-4 max-w-xs transform transition-all duration-300 ease-out origin-bottom-left relative p-0 
            ${
              isBubbleAnimated ? "scale-100 opacity-100" : "scale-90 opacity-0"
            }`}
        >
          <div className="p-4">
            <div className="flex items-center mb-2">
              <img
                src="https://hermes.dio.me/files/assets/41797cca-c230-4b5f-99b5-2c350dbf4019.png"
                alt={name}
                className="w-10 h-10 rounded-full mr-3"
              />
              <div>
                <h3 className="font-bold text-gray-800">{name}</h3>
                <div className="w-full h-0.5 bg-green-500 mt-0.5"></div>
              </div>
            </div>
            <p className="text-sm text-gray-700 mt-2">{formattedMessage}</p>
          </div>
          <div className="absolute -bottom-2 left-4 w-4 h-4 bg-white transform rotate-45"></div>
          <button
            onClick={handleBubbleClose}
            className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 p-1"
            aria-label="Fechar"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      )}

      <button
        onClick={handleWhatsAppRedirect}
        className="bg-transparent"
        aria-label="WhatsApp Support"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="85"
          height="85"
          fill="none"
          viewBox="0 0 85 85"
        >
          <g clipPath="url(#clip0_3543_1107)">
            <g filter="url(#filter0_f_3543_1107)">
              <path
                fill="#B3B3B3"
                d="M26.454 67.035l1.084.642a29.666 29.666 0 0015.1 4.126h.011c16.352 0 29.66-13.279 29.667-29.6.003-7.91-3.08-15.347-8.681-20.942a29.474 29.474 0 00-9.616-6.437 29.517 29.517 0 00-11.358-2.243c-16.364 0-29.672 13.277-29.678 29.598a29.485 29.485 0 004.535 15.753l.706 1.12-2.998 10.922 11.228-2.939zm-19.798 11.4l5.064-18.454a35.498 35.498 0 01-4.764-17.805C6.964 22.54 22.976 6.564 42.65 6.564c9.547.005 18.509 3.714 25.249 10.445 6.74 6.732 10.448 15.68 10.444 25.196-.008 19.635-16.022 35.613-35.694 35.613h-.015a35.728 35.728 0 01-17.056-4.335L6.656 78.435z"
              ></path>
            </g>
            <path
              fill="#fff"
              d="M6.29 78.069l5.064-18.454A35.496 35.496 0 016.59 41.81C6.598 22.173 22.609 6.198 42.284 6.198c9.547.005 18.509 3.713 25.248 10.445 6.74 6.732 10.448 15.68 10.445 25.196-.009 19.635-16.022 35.613-35.694 35.613h-.015a35.728 35.728 0 01-17.056-4.335L6.29 78.069z"
            ></path>
            <path
              fill="url(#paint0_linear_3543_1107)"
              d="M42.294 12.215c-16.364 0-29.672 13.278-29.678 29.598a29.484 29.484 0 004.535 15.753l.706 1.12-2.998 10.923 11.229-2.939 1.084.641a29.67 29.67 0 0015.1 4.127h.011c16.352 0 29.66-13.28 29.666-29.601a29.367 29.367 0 00-2.238-11.339 29.413 29.413 0 00-6.443-9.603 29.474 29.474 0 00-9.616-6.437 29.52 29.52 0 00-11.358-2.243z"
            ></path>
            <path
              fill="#fff"
              fillRule="evenodd"
              d="M33.362 26.922c-.668-1.482-1.372-1.512-2.007-1.538l-1.71-.02c-.594 0-1.56.222-2.377 1.113-.817.89-3.122 3.044-3.122 7.424 0 4.379 3.196 8.61 3.641 9.205.446.595 6.17 9.868 15.235 13.436 7.534 2.966 9.067 2.376 10.703 2.228 1.635-.148 5.276-2.153 6.019-4.232.742-2.079.743-3.86.52-4.232-.222-.372-.817-.593-1.71-1.039-.892-.445-5.276-2.599-6.094-2.896-.817-.297-1.411-.445-2.007.446-.595.891-2.302 2.895-2.823 3.49-.52.593-1.04.668-1.932.223-.893-.445-3.765-1.385-7.172-4.418-2.651-2.36-4.441-5.273-4.962-6.164-.521-.89-.055-1.372.392-1.816.4-.399.892-1.04 1.338-1.559.447-.52.594-.89.891-1.484.297-.593.149-1.114-.074-1.559-.223-.445-1.956-4.848-2.749-6.608z"
              clipRule="evenodd"
            ></path>
          </g>
          <defs>
            <filter
              id="filter0_f_3543_1107"
              width="85.811"
              height="85.995"
              x="-0.406"
              y="-0.498"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              ></feBlend>
              <feGaussianBlur
                result="effect1_foregroundBlur_3543_1107"
                stdDeviation="3.531"
              ></feGaussianBlur>
            </filter>
            <linearGradient
              id="paint0_linear_3543_1107"
              x1="41.678"
              x2="41.978"
              y1="15.769"
              y2="66.379"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#57D163"></stop>
              <stop offset="1" stopColor="#23B33A"></stop>
            </linearGradient>
            <clipPath id="clip0_3543_1107">
              <path fill="#fff" d="M0 0H85V85H0z"></path>
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
  );
};

export default WhatsAppSupport;
